/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import $ from 'jquery';
import { load } from '@shopify/theme-sections';
import Variants from '@shopify/theme-variants';
import { formatMoney } from '@shopify/theme-currency';
import { register } from '@shopify/theme-sections';
import Swiper, { Navigation, FreeMode, Thumbs, A11y, Keyboard } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

const selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productImageWrapper: '[data-product-image-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-page]',
    productPrice: '[data-product-price]',
    productThumbnailsSlider: 'carousel--product-thumbnails',
    productFeatureSlider: 'carousel--featured-product',
    productThumbs: '[data-product-single-thumbnail]',
    radioOptionSelector: '[data-radio-option-selector]',
    singleOptionSelector: '[data-single-option-selector]',
    productMediaWrapper: '[data-product-single-media-wrapper]',
    productMediaTypeVideo: '[data-product-media-type-video]',
    productMediaTypeModel: '[data-product-media-type-model]',
    variantOptionLabels: '.swatch__option label',
    quantity: '#Quantity',
    productSwiperThumbs: null,
    productSwiperFeature: null
};

const cssClasses = {
    activeThumbnail: 'active-thumbnail',
    hide: 'hide',
};

function toggleInnerFocus(slider) {
    let focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
    $(focusableElements).each(function (index, el) {
        $(slider.slides).each(function (index, slide) {
            if (index === slider.activeIndex) {
                if (el === '.plyr') {
                    $(slide).find(el)
                        .attr('tabindex', "0");
                } else {
                    $(slide).find(el)
                        .removeAttr('tabindex');
                }
            } else {
                $(slide)
                    .find(el)
                    .attr('tabindex', '-1');
            }
        })
    })
}

$(document).ready(function () {
    var ProductVideo = (function () {
        var videos = {};

        var hosts = {
            html5: 'html5',
            youtube: 'youtube'
        };

        var attributes = {
            enableVideoLooping: 'enable-video-looping',
            videoId: 'video-id'
        };

        function init(videoContainer, sectionId) {
            if (!videoContainer.length) {
                return;
            }

            var videoElement = videoContainer.find('iframe, video')[0];
            var mediaId = videoContainer.data('mediaId');

            if (!videoElement) {
                return;
            }

            videos[mediaId] = {
                mediaId: mediaId,
                sectionId: sectionId,
                host: hostFromVideoElement(videoElement),
                container: videoContainer,
                element: videoElement,
                ready: function () {
                    createPlayer(this);
                }
            };

            var video = videos[mediaId];
            switch (video.host) {
                case hosts.html5:
                    setupPlyrVideos();
                    break;
                case hosts.youtube:
                    setupYouTubeVideos();
                    break;
            }
        }

        function setupPlyrVideos() {
            // if (errors) {
            //   fallbackToNativeVideo();
            //   return;
            // }

            loadVideos(hosts.html5);
        }

        function setupYouTubeVideos() {

            window.YT.ready(function () {
                loadVideos(hosts.youtube);
            });
        }

        function createPlayer(video) {
            if (video.player) {
                return;
            }

            var productMediaWrapper = video.container.closest(
                selectors.productMediaWrapper
            );
            var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

            switch (video.host) {
                case hosts.html5:
                    // eslint-disable-next-line no-undef
                    video.player = new Shopify.Plyr(video.element, {
                        loop: { active: enableLooping }
                    });

                    video.player.on('ready', function () {
                        toggleInnerFocus(selectors.productSwiperFeature);
                    })
                    break;
                case hosts.youtube:
                    var videoId = productMediaWrapper.data(attributes.videoId);

                    video.player = new YT.Player(video.element, {
                        videoId: videoId,
                        events: {
                            onStateChange: function (event) {
                                if (event.data === 0 && enableLooping) event.target.seekTo(0);
                            }
                        }
                    });
                    break;
            }

            productMediaWrapper.on('mediaHidden xrLaunch', function () {
                if (!video.player) return;

                if (video.host === hosts.html5) {
                    video.player.pause();
                }

                if (video.host === hosts.youtube && video.player.pauseVideo) {
                    video.player.pauseVideo();
                }
            });

            productMediaWrapper.on('mediaVisible', function () {
                if (!video.player) return;

                if (video.host === hosts.html5) {
                    video.player.play();
                }

                if (video.host === hosts.youtube && video.player.playVideo) {
                    video.player.playVideo();
                }
            });
        }

        function hostFromVideoElement(video) {
            if (video.tagName === 'VIDEO') {
                return hosts.html5;
            }

            if (video.tagName === 'IFRAME') {
                if (
                    /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                        video.src
                    )
                ) {
                    return hosts.youtube;
                }
            }
            return null;
        }

        function loadVideos(host) {
            for (var key in videos) {
                if (videos.hasOwnProperty(key)) {
                    var video = videos[key];
                    if (video.host === host) {
                        video.ready();
                    }
                }
            }
        }

        function fallbackToNativeVideo() {
            for (var key in videos) {
                if (videos.hasOwnProperty(key)) {
                    var video = videos[key];

                    if (video.nativeVideo) continue;

                    if (video.host === hosts.html5) {
                        video.element.setAttribute('controls', 'controls');
                        video.nativeVideo = true;
                    }
                }
            }
        }

        function removeSectionVideos(sectionId) {
            for (var key in videos) {
                if (videos.hasOwnProperty(key)) {
                    var video = videos[key];

                    if (video.sectionId === sectionId) {
                        if (video.player) video.player.destroy();
                        delete videos[key];
                    }
                }
            }
        }

        return {
            init: init,
            hosts: hosts,
            loadVideos: loadVideos,
            removeSectionVideos: removeSectionVideos
        };
    })();

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    register('product', {
        onLoad() {
            this.$container = $(this.container);
            this.namespace = `.${this.id}`;
            var self = this;

            // Stop parsing if we don't have the product json script tag when loading
            // section in the Theme Editor
            if (!$(selectors.productJson, this.$container).html()) {
                return;
            }

            this.productSingleObject = JSON.parse(
                $(selectors.productJson, this.$container).html(),
            );

            const options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                radioOptionSelector: this.radioOptionSelector,
                singleOptionSelector: selectors.singleOptionSelector,
                originalSelectorId: selectors.originalSelectorId,
                product: this.productSingleObject,
            };

            this.settings = {};
            this.variants = new Variants(options);
            this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

            this.$container.on(
                `variantChange${this.namespace}`,
                this.updatePDPInformation.bind(this)
            );
            this.$container.on(
                `variantPriceChange${this.namespace}`,
                this.updateProductPrices.bind(this),
            );
            this.$container.on(
                `variantChange${this.namespace}`,
                this.updateVariantContents.bind(this),
            );



            $('.form__increment').on('click', function () {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });

            $(selectors.quantity).on('change', function () {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });

            if (this.$featuredImage.length > 0) {
                this.$container.on(
                    `variantImageChange${this.namespace}`,
                    this.updateImages.bind(this),
                );
            }

            this.initProductCarousel();
            this.initProductVideo();
            this.updateImages({
                variant: this.variants.currentVariant
            });
            this.updateVariantAvailability(this.$container[0], this.variants.currentVariant);
            this.initStickyCart();
        },

        initProductVideo: function () {
            var sectionId = this.id;
            $(selectors.productMediaTypeVideo, this.$container).each(function () {
                var $el = $(this);
                ProductVideo.init($el, sectionId);
            });
        },

        initProductCarousel: function () {
            let self = this;

            if ($('.' + selectors.productThumbnailsSlider + '').length) {

                // -------------------------------------
                // Carousel Products
                // -------------------------------------
                const productThumbnailSwiper = new Swiper('.' + selectors.productThumbnailsSlider + '', {
                    // Optional parameters
                    modules: [FreeMode, Navigation, A11y, Keyboard],
                    slidesPerView: 4,
                    freeMode: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    navigation: true,

                    keyboard: {
                        enabled: false
                    },
                    a11y: false,
                    breakpoints: {
                        // when window width is >= 680px
                        680: {
                            direction: "vertical",
                            slidesPerView: 7,
                            spaceBetween: 10
                        }
                    },
                    multipleActiveThumbs: false
                });

                const productFeatureSwiper = new Swiper('.' + selectors.productFeatureSlider + '', {
                    // Optional parameters
                    modules: [Navigation, Thumbs],
                    spaceBetween: 0,

                    // // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next-product',
                        prevEl: '.swiper-button-prev-product',
                    },
                    thumbs: {
                        swiper: productThumbnailSwiper,
                    },
                    on: {
                        init: function () {
                            toggleInnerFocus(this);
                        }
                    }
                });


                productFeatureSwiper.on('slideChange ', function () {
                    // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                    var previousSlideIndex = productFeatureSwiper.previousIndex,
                        currentSlideIndex = productFeatureSwiper.activeIndex;

                    // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                    var currentMedia = $('.product__feature-image .swiper-slide[data-index="' + currentSlideIndex + '"] .product-single__media-wrapper'),
                        previousMedia = $('.product__feature-image .swiper-slide[data-index="' + previousSlideIndex + '"] .product-single__media-wrapper');

                    previousMedia.trigger("mediaHidden");
                    // currentMedia.trigger("mediaVisible");
                    toggleInnerFocus(this);

                });

                $(productFeatureSwiper.slides).each(function (index, slide) {
                    $(slide).on('keydown', function (e) {
                        if (e.key === "Escape") {
                            $(productThumbnailSwiper.slides).each(function (i, thumbnailSlide) {
                                $(thumbnailSlide).attr('tabindex', '0');
                            })

                            productThumbnailSwiper.slides[index].focus();
                        }
                    })
                })



                $(productThumbnailSwiper.slides).each(function (index, slide) {
                    $(slide).on('focus', function (e) {
                        let slideIndex = slide.getAttribute('data-index');
                        self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                        self.slideToSlide(productFeatureSwiper, slideIndex, true);
                        $(productThumbnailSwiper.slides).each(function (i, thumbnailSlide) {
                            $(thumbnailSlide).attr('tabindex', '0');
                        })
                    })
                    $(slide).on('keydown', function (e) {
                        if (e.key === "Enter") {
                            $(productThumbnailSwiper.slides).each(function (i, thumbnailSlide) {
                                $(thumbnailSlide).attr('tabindex', '-1');
                            })
                            $(slide).attr('tabindex', '0');
                            let slideIndex = parseInt(slide.getAttribute('data-index'));
                            productFeatureSwiper.slides[slideIndex].focus();
                        }
                    })
                });

                $(productThumbnailSwiper.navigation.nextEl).on('click', function (e) {
                    let slideIndex = productThumbnailSwiper.activeIndex;
                    self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                    self.slideToSlide(productFeatureSwiper, slideIndex, true);
                })

                $(productThumbnailSwiper.navigation.prevEl).on('click', function (e) {
                    let slideIndex = productThumbnailSwiper.activeIndex;
                    self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                    self.slideToSlide(productFeatureSwiper, slideIndex, true);
                })



                selectors.productSwiperThumbs = productThumbnailSwiper;
                selectors.productSwiperFeature = productFeatureSwiper;
            }

        },


        initVariantTitles() {
            this.changeVariantTitles(this.variants.currentVariant);
        },
        disableVariants(target, valuesToEnable, outOfStockValues) {
            const optionSelectors = Array.from($(target).find('[data-index^="option"]'));

            optionSelectors.forEach(optionSelector => {
                const isSwatchSelector = optionSelector.getAttribute('type') === 'radio';
                const optionIndex = optionSelector.getAttribute('data-index');
                const optionInputs = Array.from($(target).find(`input[data-index="${optionIndex}"]`));
                const optionCount = optionInputs.length;

                // Project's specific request - Do not hide level 1 variant
                if (optionIndex != 'option1') {
                    optionInputs.forEach(input => {
                        const inputElement = input.nextElementSibling;

                        $(inputElement).removeClass('swatch--disabled');
                        $(inputElement).removeClass('swatch--out-of-stock');

                        const optionValue = input.value;
                        const valuesToEnableForOption = valuesToEnable[optionIndex];
                        const outOfStockValuesForOption = outOfStockValues[optionIndex];

                        // Add disabled class if the variant is unavailable / does not exist
                        if (!valuesToEnableForOption.includes(optionValue)) {
                            $(inputElement).addClass('swatch--disabled');
                        }

                        // Add out-of-stock class if the variant is out of stock
                        if (outOfStockValuesForOption.includes(optionValue)) {
                            $(inputElement).addClass('swatch--out-of-stock');
                        }
                    });

                    if (isSwatchSelector) {
                        if (optionCount === 1) {
                            const input = optionInputs[0];
                            $(input).attr('checked', true);
                        } else {
                            optionInputs.forEach(input => {
                                const inputElement = input.nextElementSibling;
                                // Add disabled class if the variant is unavailable / does not exist
                                if (!valuesToEnable[optionIndex].includes(input.value)) {
                                    $(inputElement).addClass('swatch--disabled');
                                }

                                // Add out-of-stock class if the variant is out of stock
                                if (outOfStockValues[optionIndex].includes(input.value)) {
                                    $(inputElement).addClass('swatch--out-of-stock');
                                }
                            });
                        }
                    }
                }
            });
        },

        updateVariantAvailability(target, variant) {

            // Loop through all the Option Selectors and check which one is a swatch selector
            var optionSelector1 = $(target).find('[data-index="option1"]');
            var optionSelector2 = $(target).find('[data-index="option2"]');
            var optionSelector3 = $(target).find('[data-index="option3"]');
            var is_swatch_selector1 = false;
            var is_swatch_selector2 = false;
            var is_swatch_selector3 = false;

            if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            var variants = this.variants.product.variants;
            var currentSelectedOptions = this.variants._getCurrentOptions();

            /**
             * Available Variants
            /**
             * Getting the available variants if there are 2 levels of variant options
             */

            // Available variant values
             var availableValues = {
                option1: [],
                option2: [],
                option3: []
            }
            // Check if there are 2 option selectors. Combine all available variant
            if (optionSelector2.length) {
                var availableVariantsTwoLevels = variants.filter(function (el) {
                    if (!el.available) {
                        return false;
                    }

                    var currentVariant = {
                        option1: currentSelectedOptions[0].value,
                        option2: currentSelectedOptions[1].value
                    };
                    // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                    if (is_swatch_selector2 == true) {

                        return currentVariant.option1 === el.option1 || !el.option1;

                        // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2.
                    } else if (is_swatch_selector1 == true) {

                        return currentVariant.option2 === el.option2 || !el.option2;
                    }
                });

                var availableVariantsTwoLevels_object = Object.assign({}, availableVariantsTwoLevels);

                for (var property in availableVariantsTwoLevels_object) {
                    if (availableVariantsTwoLevels_object.hasOwnProperty(property)) {
                        var item = availableVariantsTwoLevels_object[property],
                            option1 = item.option1,
                            option2 = item.option2;

                        if (option1) {
                            if (availableValues.option1.indexOf(option1) === -1) {
                                availableValues.option1.push(option1);
                            }
                        }
                        if (option2) {
                            if (availableValues.option2.indexOf(option2) === -1) {
                                availableValues.option2.push(option2);
                            }
                        }
                    }
                }
            }

            /**
             * Getting the available variants if there are 3 levels of variant options
             */
            // Check if there are 3 option selectors. Combine all available variant
            if ( optionSelector3.length && availableVariantsTwoLevels.length ) {
                var availableVariantsThreeLevels = availableVariantsTwoLevels.filter(function (el) {
                    if (!el.available) {
                        return false;
                    }

                    var currentVariant = {
                        option1: currentSelectedOptions[0].value,
                        option2: currentSelectedOptions[1].value
                    };

                    // If the third option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 2.
                    if (is_swatch_selector3 == true) {

                        // Option 3 based on selected Option 1 and 2
                        return (currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option2 === el.option2 || !el.option2);
                    }
                });

                availableVariantsThreeLevels = Object.assign({}, availableVariantsThreeLevels);

                for (var property in availableVariantsThreeLevels) {
                    if (availableVariantsThreeLevels.hasOwnProperty(property)) {
                        var item = availableVariantsThreeLevels[property],
                            option3 = item.option3;

                        if (option3) {
                            if (availableValues.option3.indexOf(option3) === -1) {
                                availableValues.option3.push(option3);
                            }
                        }
                    }
                }
            }
            /**
             * Out-of-stock Variants
            /**
             * Getting the out-of-stock variants if there are 2 levels of variant options
             */

            // Out-of-stock variant values
            var outOfStockValues = {
                option1: [],
                option2: [],
                option3: []
            }

            // Check if there are 2 option selectors. Combine all available variant
            if (optionSelector2.length) {
                var outOfStockVariantsTwoLevels = variants.filter(function (el) {
                    if (!el.available) {

                        var currentVariant = {
                            option1: currentSelectedOptions[0].value,
                            option2: currentSelectedOptions[1].value
                        };

                        // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                        if (is_swatch_selector2 == true) {

                            return currentVariant.option1 === el.option1 || !el.option1;

                            // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2.
                        } else if (is_swatch_selector1 == true) {

                            return currentVariant.option2 === el.option2 || !el.option2;
                        }
                    }
                });

                var outOfStockVariantsTwoLevels_object = Object.assign({}, outOfStockVariantsTwoLevels);

                for (var property in outOfStockVariantsTwoLevels_object) {
                    if (outOfStockVariantsTwoLevels_object.hasOwnProperty(property)) {
                        var item = outOfStockVariantsTwoLevels_object[property],
                            option1 = item.option1,
                            option2 = item.option2;

                        if (option1) {
                            if (outOfStockValues.option1.indexOf(option1) === -1) {
                                outOfStockValues.option1.push(option1);
                            }
                        }
                        if (option2) {
                            if (outOfStockValues.option2.indexOf(option2) === -1) {
                                outOfStockValues.option2.push(option2);
                            }
                        }
                    }
                }
            }

            /**
             * Getting the out-of-stock variants if there are 3 levels of variant options
             */
            if ( optionSelector3.length ) {
                // Combine all variants for all 3 levels based on selected level 1 or level 2
                var variantsBasedOnTwoLevels = variants.filter(function (el) {
                    var currentVariant = {
                        option1: currentSelectedOptions[0].value,
                        option2: currentSelectedOptions[1].value
                    };

                    // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                    if (is_swatch_selector2 == true) {
                        return currentVariant.option1 === el.option1 || !el.option1;

                        // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2.
                    } else if (is_swatch_selector1 == true) {
                        return currentVariant.option2 === el.option2 || !el.option2;
                    }
                });

                if (variantsBasedOnTwoLevels.length) {
                    var outOfStockVariantsThreeLevels = variantsBasedOnTwoLevels.filter(function (el) {
                        if (!el.available) {

                            var currentVariant = {
                                option1: currentSelectedOptions[0].value,
                                option2: currentSelectedOptions[1].value
                            };

                            // If the third option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 2.
                            if (is_swatch_selector3 == true) {
                                // Option 3 based on selected Option 1 and 2
                                return (currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option2 === el.option2 || !el.option2);
                            }
                        }
                    });

                    var outOfStockVariantsThreeLevels_object = Object.assign({}, outOfStockVariantsThreeLevels);

                    for (var property in outOfStockVariantsThreeLevels_object) {
                        if (outOfStockVariantsThreeLevels_object.hasOwnProperty(property)) {
                            var item = outOfStockVariantsThreeLevels_object[property],
                                option3 = item.option3;

                            if (option3) {
                                if (outOfStockValues.option3.indexOf(option3) === -1) {
                                    outOfStockValues.option3.push(option3);
                                }
                            }
                        }
                    }
                }
            }

            this.disableVariants(target, availableValues, outOfStockValues);
        },

        slideToSlide(slider, slideIndex, transition) {
            if (transition) {
                slider.slideTo(slideIndex);
            } else {
                slider.slideTo(slideIndex, 0);
            }
        },

        // triggering change image when using with Slider
        swapImage(imageId) {

            let newImageId = imageId;

            // If "imageId" is not defined in the function parameter, find it by the current product image
            if (typeof newImageId === 'undefined') {
                newImageId = $(
                    `${selectors.productImageWrapper}:not('.${cssClasses.hide}')`,
                ).data('image-id');
            }

            const $thumbnail = $(
                `${selectors.productThumbs}[data-thumbnail-id='${newImageId}']`,
            );

            var slideIndex = parseInt($thumbnail.parents('.swiper-slide').attr('data-index'));

            // Swipe JS
            if ($('.' + selectors.productThumbnailsSlider + '').length) {
                this.slideToSlide(selectors.productSwiperThumbs, slideIndex, false);
                this.slideToSlide(selectors.productSwiperFeature, slideIndex, false);
            }
        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState(evt) {
            const variant = evt.variant;
            this.updateVariantAvailability(evt.target, variant);

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass(cssClasses.hide);

            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.unavailable,
                );
                $(selectors.priceWrapper, this.$container).addClass(cssClasses.hide);
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        changeVariantTitles(evt) {
            $('.swatch__option input[data-single-option-selector]:checked').each(function () {
                var container = $(this).parents('.form__element');
                var subtitle = container.find('.swatch__title .swatch__subtitle');
                subtitle.text($(this).val());
            })
        },

        tempChangeVariantTitle(evt) {
            var target = evt.currentTarget;
            var newLabel = target.innerText;
            var container = $(target).parents('.form__element');
            var subtitle = container.find('.swatch__title .swatch__subtitle');
            subtitle.text(newLabel);
        },

        initVariantHoverWatch() {
            var changeVariantTitles = this.changeVariantTitles;
            var tempChangeVariantTitle = this.tempChangeVariantTitle;
            $('.swatch__option input[data-single-option-selector] + label.form__option-label').each(function () {
                $(this).on('mouseenter', tempChangeVariantTitle).on('mouseleave', changeVariantTitles);
            });
        },

        updatePDPInformation(evt) {
            this.updateAddToCartState(evt);
        },

        updateImages(evt) {
            const variant = evt.variant;

            if (typeof variant.featured_media != 'undefined') {

                const imageId = this.id + "-" + variant.featured_media.id;

                this.swapImage(imageId);
            }
        },

        updateVariantContents(evt) {
            const variant = evt.variant;
            if (variant == null) {
                $('#variant-contents').empty();
                $('#variant-title').empty();
                $('#variant-sku').empty();
            } else {

                if (theme.variants[variant.id].contents !== null && theme.variants[variant.id].contents != "") {
                    $('#variant-contents').html(theme.variants[variant.id].contents);
                } else {
                    $('#variant-contents').empty();
                }

                if (theme.variants[variant.id].sku !== null && theme.variants[variant.id].sku != "") {
                    $('#variant-sku').html(theme.variants[variant.id].sku);
                } else {
                    $('#variant-sku').empty();
                }

                if (theme.variants[variant.id].title !== null && theme.variants[variant.id].title != "") {
                    $('#variant-title').html(theme.variants[variant.id].title);
                } else {
                    $('#variant-title').empty();
                }
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices(evt) {
            const variant = evt.variant;
            const $comparePrice = $(selectors.comparePrice, this.$container);
            const $compareEls = $comparePrice.add(
                selectors.comparePriceText,
                this.$container,
            );
            const quantity = parseInt($(selectors.quantity).val());

            $(selectors.productPrice, this.$container).html(
                formatMoney(variant.price, theme.moneyFormat),
            );

            const priceWithQuantity = variant.price * quantity;
            $('#addToCartPricing').html(
                formatMoney(priceWithQuantity, theme.moneyFormat),
            );

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(
                    formatMoney(variant.compare_at_price, theme.moneyFormat),
                );
                $compareEls.removeClass(cssClasses.hide);
            } else {
                $comparePrice.html('');
                $compareEls.addClass(cssClasses.hide);
            }
        },

        initStickyCart() {
            let options = {
                rootMargin: '100px 0px 0px 0px',
                threshold: [0, 0.01, 1]
            }

            let target = document.querySelector('#productStickyContainer');

            let observer = new IntersectionObserver(this.showHideStickyCart, options);

            observer.observe(target);

            // Mobile cart button
            $('#addToCartSticky').on('click', function () {
                target.scrollIntoView({ behavior: 'smooth' });
            })

        },

        showHideStickyCart(entries, observer) {
            let entry = entries[0];
            if (entry.intersectionRatio >= 1) {
                entry.target.classList.remove('product__sticky--show');
            } else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
                entry.target.classList.add('product__sticky--show');
                entry.target.classList.remove('product__sticky--hide');
            } else {
                entry.target.classList.add('product__sticky--hide');
            }
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
            this.$container.off(this.namespace);
        },
    });

    load('product');
})
